"use strict";

import Vue from 'vue';

// Register a global click event directive
Vue.directive('global-click-event', {
    bind (el, binding, vnode) {
        el.addEventListener('click', (event) => {
            event.stopImmediatePropagation()
        })
        document.body.addEventListener('click', () => {
            binding.value()
        })
    },   
    unbind(el, binding, vnode) {
        el.removeEventListener('click', (event) => {
            event.stopImmediatePropagation()
        })
        document.body.removeEventListener('click', () => {
            binding.value()
        })
    },
  })



// WEBPACK FOOTER //
// ./resources/wob/vue/directives/globalClickEvent.js